import React from 'react';

import {
  AddOrEditModal,
  ExpensesModal,
} from '@/modules/workingDayReconciliation/components/CrewLevel/DetailedCard/Modal';
import { IReconciliation } from '@/modules/workingDayReconciliation/types';
import { useStore } from '@/shared/hooks/context/createGenericContext';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface Props {
  modalType: IReconciliation.IModalType;
  operationType: IReconciliation.IModalOperationType;
  currentSupplierSummary: IReconciliation.IGetWorkdaySummary | null;
}

const ChooseModal: React.FC<Props> = ({
  modalType,
  operationType,
  currentSupplierSummary,
}) => {
  const [selectedAsset] = useStore((store) => store?.asset);

  const selectModalByType = () => {
    const modalProps = {
      entityId: selectedAsset?.id,

      currentSupplierSummary,
      expenseType: modalType,
      operationType: operationType,
    };

    switch (operationType) {
      case 'view':
        return <ExpensesModal {...modalProps} />;
      case 'add':
      case 'edit':
        return <AddOrEditModal {...modalProps} />;
      // case 'delete':
      //   return <DeleteModal />;

      default:
        return null;
    }
  };
  const selectModalByTypeReturn = selectModalByType();
  if (!selectModalByTypeReturn) return <></>;

  return operationType === 'view' ? (
    <div className='flex max-h-[80vh] min-h-[30vh] w-full min-w-[80vw] flex-col overflow-y-auto px-2  scrollbar-thin scrollbar-track-background-100 scrollbar-thumb-background-disable scrollbar-track-rounded-lg scrollbar-thumb-rounded-lg scrollbar-w-5  scrollbar-h-5'>
      {selectModalByTypeReturn}
    </div>
  ) : (
    selectModalByTypeReturn
  );
};
export default ChooseModal;
